/**
 * Maps ENR-UX-009 canonical primary-action intents to existing Studio action ids.
 */
export function mapCanonicalIntentToStudioActionId(intent: string | undefined): string | null {
  switch (intent) {
    case "START_PROJECT_BUILD":
    case "RETRY_PROJECT_BUILD":
      return "confirm-build";
    case "OPEN_QUALITY_GATE_REVIEW":
      return "resolve-quality-issues";
    case "OPEN_EXACT_PREVIEW":
    case "SHARE_EXACT_PREVIEW":
      return "copy-preview";
    case "PACKAGE_HANDOFF":
      return "package-handoff";
    case "OPEN_SAFE_EDIT_ATTENTION":
      return "open-live-care";
    default:
      return null;
  }
}
